export const PRIVATE_CHANNEL = 'send-user';
export const GLOBAL_CHANNEL = 'notify-user'; // cheat, we are skipping real broadcast for now (whuich won't be handled in the v4 anyway)
